import { lazy } from "react";
const Loader = lazy(() => import("./component"));
export default Loader;
